import { render, staticRenderFns } from "./ClienteSidebar.vue?vue&type=template&id=90321b46"
import script from "./ClienteSidebar.vue?vue&type=script&lang=js"
export * from "./ClienteSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports